import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Security from './components/Security';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/d5a68c31-78ff-4f7c-bf4e-65f5a709fee4.png" 
              alt="DISTRIEM LTDA Logo" 
              className="h-10 w-auto"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              DISTRIEM LTDA
            </span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className={`text-sm font-medium transition-colors hover:text-cyan-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              About
            </a>
            <a href="#features" className={`text-sm font-medium transition-colors hover:text-cyan-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Features
            </a>
            <a href="#security" className={`text-sm font-medium transition-colors hover:text-cyan-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Security
            </a>
            <a href="#contact" className={`text-sm font-medium transition-colors hover:text-cyan-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </a>
          </div>
          <a 
            href="#contact" 
            className="hidden md:block px-6 py-2.5 bg-cyan-500 text-white text-sm font-semibold rounded-full hover:bg-cyan-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Started
          </a>
        </div>
      </nav>

      <Hero />
      <About />
      <Features />
      <Security />
      <Contact />
      <Footer />
    </div>
  );
}
